import React from 'react'
import { Link } from 'react-router-dom'
import * as ROUTES from '../../utils/constants/routes'
export default function Faq() {
    return (
        <section className="faq-area ptb-200">
            <div className="container">
                <div className="section-title">
                    <h2>Frequently Asked Questions</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                </div>

                <div className="faq-accordion-content">
                    <ul className="accordion">
                        <li className="accordion-item">
                            <a className="accordion-title active" href="javascript:void(0)">
                                <i className="flaticon-plus"></i>
                                What is Child Hope international children ministries?
                            </a>

                            <p className="accordion-content show">We are a nonprofit organizations in Kampala, Uganda, which focuses on children who are orphans, have single parents, are homeless, sexually abused, living in abject poverty as side effects of war and HIV/AIDS. Our mission is to help these children break free from poverty.</p>
                        </li>
                        
                        <li className="accordion-item">
                            <a className="accordion-title" href="javascript:void(0)">
                                <i className="flaticon-plus"></i>
                                How did you get started (and when)?
                            </a>

                            <p className="accordion-content">We have been around for quite some time. Our organization opened in 2009, and from the very start has been dedicated to providing education, shelter and health care to orphans and homeless children. Today, we serve over 500 children and youth in our program.</p>
                        </li>
                        
                        <li className="accordion-item">
                            <a className="accordion-title" href="javascript:void(0)">
                                <i className="flaticon-plus"></i>
                                How can I work at your organization?
                            </a>

                            <p className="accordion-content">We’re always looking for the most passionate people in the public to join us and extend a helping hand. Are you passionate about teaching, counseling, have you been trained in the health sciences? Reach out to us to volunteer your time and services to these lovely children.</p>
                        </li>

                        <li className="accordion-item">
                            <a className="accordion-title" href="javascript:void(0)">
                                <i className="flaticon-plus"></i>
                                I want to help. How can I be sure you’re putting my donation to good use?
                            </a>

                            <p className="accordion-content">Firstly, It’s good to do your homework, especially when it comes to how you spend your giving money. We ensure that the majority of our total expenses support the programs and activities that help our kids. We keep our contacts <Link to ={ROUTES.CONTACT} style={{color:'blue',textDecoration:"underline"}}>here</Link>  , If you are particularly interested kindly reach out to us and we’ll forward you our annual reports and our audited financial statements.</p>
                        </li>
                        
                        <li className="accordion-item">
                            <a className="accordion-title" href="javascript:void(0)">
                                <i className="flaticon-plus"></i>
                                Do you provide scholarships?
                            </a>

                            <p className="accordion-content">Yes. Our Child Hope Fund provides scholarships for qualified youth to continue their education through kindergarten, primary and secondary school, vocational training and higher education.
                             If you’d like to know more, get in touch with our <Link to ={ROUTES.TEAM} style={{color:'blue',textDecoration:"underline"}}>Care Team</Link> and we’ll walk you through the process to determine how you can provide assistance for your child or any qualified teen.
</p>
                        </li>
                        
                        <li className="accordion-item">
                            <a className="accordion-title" href="javascript:void(0)">
                                <i className="flaticon-plus"></i>
                                Can I visit my child?
                            </a>

                            <p className="accordion-content">You should definitely visit your child! Imagine how great it would be to see the impact of your sponsorship in person! Reach out to us and this will be arranged.</p>
                        </li>

                       
                    </ul>
                </div>

                <div className="faq-contact">
                    <div className="section-title">
                        <h2>Do You Have Any Questions?</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    </div>

                    <div className="faq-contact-form">
                        <form id="contactForm" novalidate="true">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <input type="text" name="name" id="name" className="form-control" required="" data-error="Please enter your name" placeholder="Name"/>
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <input type="email" name="email" id="email" className="form-control" required="" data-error="Please enter your email" placeholder="Email"/>
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <input type="text" name="phone_number" id="phone_number" required="" data-error="Please enter your number" className="form-control" placeholder="Phone"/>
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <input type="text" name="msg_subject" id="msg_subject" className="form-control" required="" data-error="Please enter your subject" placeholder="Subject"/>
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>

                                <div className="col-lg-12 col-md-12">
                                    <div className="form-group">
                                        <textarea name="message" className="form-control" id="message" cols="30" rows="6" required="" data-error="Write your message" placeholder="Your Message"></textarea>
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>

                                <div className="col-lg-12 col-md-12">
                                    <div className="send-btn">
                                        <button type="submit" className="optional-btn disabled" style={{pointerEvents: "all", cursor: 'pointer'}}>Send Message</button>
                                    </div>
                                    <div id="msgSubmit" className="h3 text-center hidden"></div>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}
